(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["banner-papeis"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.bp-section').forEach(function(section) {
  var track = section.querySelector('.bp-track');
  var slides = section.querySelectorAll('.bp-slide');
  var prevBtn = section.querySelector('.bp-prev');
  var nextBtn = section.querySelector('.bp-next');
  var currentIndex = 0;

  /* =========================================================
     CARROSSEL
     ========================================================= */

  function getVisibleSlides() {
    return 2;
  }

  function update() {
    var visibleSlides = getVisibleSlides();
    var maxIndex = Math.max(0, slides.length - visibleSlides);

    if (currentIndex > maxIndex) {
      currentIndex = maxIndex;
    }

    track.style.transform =
      'translateX(-' + (currentIndex * (100 / visibleSlides)) + '%)';
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      var visibleSlides = getVisibleSlides();
      var maxIndex = Math.max(0, slides.length - visibleSlides);

      if (currentIndex < maxIndex) {
        currentIndex++;
        update();
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) {
        currentIndex--;
        update();
      }
    });
  }


  /* =========================================================
     QUANTIDADE
     ========================================================= */

  section.querySelectorAll('.bp-qty-minus').forEach(function(button) {
    button.addEventListener('click', function() {
      var card = button.closest('.bp-card');
      var input = card.querySelector('.bp-qty-input');

      if (!input) return;

      var quantity = parseInt(input.value, 10) || 1;

      if (quantity > 1) {
        input.value = quantity - 1;
      }
    });
  });

  section.querySelectorAll('.bp-qty-plus').forEach(function(button) {
    button.addEventListener('click', function() {
      var card = button.closest('.bp-card');
      var input = card.querySelector('.bp-qty-input');

      if (!input) return;

      var quantity = parseInt(input.value, 10) || 1;

      input.value = quantity + 1;
    });
  });


  /* =========================================================
     ADICIONAR AO CARRINHO
     ========================================================= */

  section.querySelectorAll('.bp-add-cart').forEach(function(button) {
    button.addEventListener('click', async function() {
      var card = button.closest('.bp-card');
      var input = card.querySelector('.bp-qty-input');

      var variantId = button.dataset.variantId;
      var quantity = parseInt(input.value, 10) || 1;

      if (!variantId) return;

      var originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'ADICIONANDO...';

      var root =
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root
          ? Shopify.routes.root
          : '/';

      try {
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: quantity
              }
            ],

            sections: [
              'cart-drawer',
              'cart-icon-bubble'
            ],

            sections_url: window.location.pathname
          })
        });

        var data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            'Não foi possível adicionar o produto.'
          );
        }

        var drawer = document.querySelector('cart-drawer');

        if (
          drawer &&
          data.sections &&
          typeof drawer.renderContents === 'function'
        ) {
          drawer.renderContents(data);
        } else if (
          drawer &&
          typeof drawer.updateCustomCartCount === 'function'
        ) {
          drawer.updateCustomCartCount();
          drawer.open();
        }

        if (input) {
          input.value = 1;
        }

      } catch (error) {
        console.error(
          'Erro ao adicionar produto ao carrinho:',
          error
        );

        button.textContent = 'TENTE NOVAMENTE';

        setTimeout(function() {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);

        return;
      }

      button.textContent = 'ADICIONADO ✓';

      setTimeout(function() {
        button.textContent = originalText;
        button.disabled = false;
      }, 1000);
    });
  });


  window.addEventListener('resize', update);
  update();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["banner-product-carousel"] && !Shopify.designMode) return;
  try {
    

document.querySelectorAll('.bpc-section').forEach(function(section) {
  var track = section.querySelector('.bpc-track');
  var slides = section.querySelectorAll('.bpc-slide');
  var prevBtn = section.querySelector('.bpc-prev');
  var nextBtn = section.querySelector('.bpc-next');
  var currentIndex = 0;

  /* =========================================================
     CARROSSEL
     ========================================================= */

  function getVisibleSlides() {
    return 2;
  }

  function update() {
    var visibleSlides = getVisibleSlides();
    var maxIndex = Math.max(0, slides.length - visibleSlides);

    if (currentIndex > maxIndex) {
      currentIndex = maxIndex;
    }

    track.style.transform =
      'translateX(-' + (currentIndex * (100 / visibleSlides)) + '%)';
  }

  if (nextBtn) {
    nextBtn.addEventListener('click', function() {
      var visibleSlides = getVisibleSlides();
      var maxIndex = Math.max(0, slides.length - visibleSlides);

      if (currentIndex < maxIndex) {
        currentIndex++;
        update();
      }
    });
  }

  if (prevBtn) {
    prevBtn.addEventListener('click', function() {
      if (currentIndex > 0) {
        currentIndex--;
        update();
      }
    });
  }


  /* =========================================================
     QUANTIDADE - / +
     ========================================================= */

  section.querySelectorAll('.bpc-qty-minus').forEach(function(button) {
    button.addEventListener('click', function() {
      var card = button.closest('.bpc-card');
      var input = card.querySelector('.bpc-qty-input');

      if (!input) return;

      var quantity = parseInt(input.value, 10) || 1;

      if (quantity > 1) {
        input.value = quantity - 1;
      }
    });
  });


  section.querySelectorAll('.bpc-qty-plus').forEach(function(button) {
    button.addEventListener('click', function() {
      var card = button.closest('.bpc-card');
      var input = card.querySelector('.bpc-qty-input');

      if (!input) return;

      var quantity = parseInt(input.value, 10) || 1;

      input.value = quantity + 1;
    });
  });


  /* =========================================================
     ADICIONAR AO CARRINHO
     ========================================================= */

  section.querySelectorAll('.bpc-add-cart').forEach(function(button) {
    button.addEventListener('click', async function() {
      var card = button.closest('.bpc-card');
      var input = card.querySelector('.bpc-qty-input');

      var variantId = button.dataset.variantId;
      var quantity = parseInt(input.value, 10) || 1;

      if (!variantId) return;

      var originalText = button.textContent;

      button.disabled = true;
      button.textContent = 'ADICIONANDO...';

      var root =
        window.Shopify &&
        Shopify.routes &&
        Shopify.routes.root
          ? Shopify.routes.root
          : '/';

      try {
        var response = await fetch(root + 'cart/add.js', {
          method: 'POST',

          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },

          body: JSON.stringify({
            items: [
              {
                id: Number(variantId),
                quantity: quantity
              }
            ],

            sections: [
              'cart-drawer',
              'cart-icon-bubble'
            ],

            sections_url: window.location.pathname
          })
        });

        var data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.description ||
            'Não foi possível adicionar o produto.'
          );
        }

        /* Atualiza e abre a aba lateral do carrinho */
        var drawer = document.querySelector('cart-drawer');

        if (
          drawer &&
          data.sections &&
          typeof drawer.renderContents === 'function'
        ) {
          drawer.renderContents(data);
        } else if (
          drawer &&
          typeof drawer.updateCustomCartCount === 'function'
        ) {
          drawer.updateCustomCartCount();
          drawer.open();
        }

        /* Volta quantidade para 1 */
        if (input) {
          input.value = 1;
        }

      } catch (error) {
        console.error(
          'Erro ao adicionar produto ao carrinho:',
          error
        );

        button.textContent = 'TENTE NOVAMENTE';

        setTimeout(function() {
          button.textContent = originalText;
          button.disabled = false;
        }, 1500);

        return;
      }

      button.textContent = 'ADICIONADO ✓';

      setTimeout(function() {
        button.textContent = originalText;
        button.disabled = false;
      }, 1000);
    });
  });


  window.addEventListener('resize', update);

  update();
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["brand-carousel"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initBrandCarousels(root) {
    root.querySelectorAll('.brand-carousel-section').forEach(function (carousel) {
      if (carousel.dataset.initialized === 'true') return;

      var track = carousel.querySelector('[data-brand-track]');
      var prev = carousel.querySelector('[data-brand-prev]');
      var next = carousel.querySelector('[data-brand-next]');

      if (!track || !prev || !next) return;
      carousel.dataset.initialized = 'true';

      function move(direction) {
        var slide = track.querySelector('.brand-carousel-slide');
        if (!slide) return;

        var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
        var target = track.scrollLeft + direction * slide.getBoundingClientRect().width;

        if (direction > 0 && track.scrollLeft >= maxScroll - 2) {
          target = 0;
        } else if (direction < 0 && track.scrollLeft <= 2) {
          target = maxScroll;
        }

        track.scrollTo({
          left: Math.max(0, Math.min(target, maxScroll)),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches
            ? 'auto'
            : 'smooth'
        });
      }

      prev.addEventListener('click', function () { move(-1); });
      next.addEventListener('click', function () { move(1); });
    });
  }

  initBrandCarousels(document);

  document.addEventListener('shopify:section:load', function (event) {
    initBrandCarousels(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target.closest('.brand-carousel-slide');
    if (!slide) return;

    var track = slide.closest('[data-brand-track]');
    if (!track) return;

    track.scrollLeft +=
      slide.getBoundingClientRect().left - track.getBoundingClientRect().left;
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["credibilidade-marketplaces"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.credibility-section').forEach(function(section) {
  const track = section.querySelector('.credibility-cards');
  const cards = section.querySelectorAll('.credibility-card');
  const prev = section.querySelector('.credibility-prev');
  const next = section.querySelector('.credibility-next');

  if (!track || !cards.length || !prev || !next) return;

  let current = 0;

  function updateSlider() {
    const cardWidth = cards[0].offsetWidth;
    track.style.transform = 'translateX(-' + (current * cardWidth) + 'px)';
  }

  next.addEventListener('click', function() {
    current = current < cards.length - 1 ? current + 1 : 0;
    updateSlider();
  });

  prev.addEventListener('click', function() {
    current = current > 0 ? current - 1 : cards.length - 1;
    updateSlider();
  });

  window.addEventListener('resize', updateSlider);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
